export default __webpack_public_path__ + "static/Safety Meetings-a86fecb2023e112b0bf97b7da5040f4e.jpg";